import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FileManagerLibFINComponent } from '../../file-manager-lib-fin/file-manager-lib-fin.component';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import Swal from 'sweetalert2';
import { User_CDMS, User_CDMS_Not_Dup } from 'src/app/Interfaces/Interfaces-Global/User_CDMS.interface';
import { Task_FIN, WorkFlow_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Create_WF/WorkFlow_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { firstValueFrom } from 'rxjs';
import { FormGroup, Validators } from '@angular/forms';
import { Annexes_Current_Last, Annexes_Current_Last_Data, FILE_CAP_Annexe_ID, FILE_CAP_Annexe_Update } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';

@Component({
    selector: 'app-update-fprocess-fin',
    templateUrl: './update-fprocess-fin.component.html',
    styleUrls: ['./update-fprocess-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css'],
    standalone: false
})
export class UpdateFProcessFINComponent extends FileManagerLibFINComponent implements OnChanges {

  public VisibleReviewersUpdate: number[] = [];
  public ReviewerUsersUnifiedUpdate: User_CDMS[] = [];
  public ReviewerUsersBySlotUpdate: { [key: number]: User_CDMS[] } = { 1: [], 2: [], 3: [], 4: [] };

  @ViewChild('UpdFile_Update_Annexe')
  MyInputUpdFile_Update_Annexe!: ElementRef;

  @ViewChild('UpdFile')
  MyInputUpdFile!: ElementRef;

  @ViewChild('UpdFileAnnexe')
  MyInputUpdFileAnnexe!: ElementRef;


  @Input() override Permission_FMF!: Permission_Folder_FIN;
  @Input() override FormFINUpdate!: FormGroup;
  @Input() override FFIN_Select_CM!: FILE_FIN;
  @Input() override FileAuxUpdFIN_Annexes!: FILE_CAP_Annexe_ID[];
  @Input() override All_FAF_FIN!: FILE_FIN[];
  @Input() override Route_Level_Global!: string;

  @Output() IsUpdateFINBool = new EventEmitter<boolean>();


  ngOnChanges(): void {
    this.RefreshReviewerUsersUnifiedUpdate();
    this.RefreshVisibleReviewersUpdate();
    this.EnaOrDis_Optional_Reviewers();
  }

  // Override: La carga individual acepta cualquier tipo de archivo.
  // El filtro de tipo de archivo solo aplica a carga masiva (On_Select_Files_Massive_FIN).
  public override Is_Valid_File(_fileName: string): boolean {
    return true;
  }

  private GetUniqueUsers(users: User_CDMS[]): User_CDMS[] {
    const usersMap = new Map<number, User_CDMS>();

    for (const user of users) {
      if (typeof user?.ID === 'number' && !usersMap.has(user.ID)) {
        usersMap.set(user.ID, user);
      }
    }

    return [...usersMap.values()];
  }

  private RefreshReviewerUsersUnifiedUpdate(): void {
    const usersByGroup = this.Permission_FMF?.Users_Groups_For_Role;

    if (!usersByGroup) {
      this.ReviewerUsersUnifiedUpdate = [];
      this.ReviewerUsersBySlotUpdate = { 1: [], 2: [], 3: [], 4: [] };
      return;
    }

    const approverGroups = [
      usersByGroup.G_Approvers_1,
      usersByGroup.G_Approvers_2,
      usersByGroup.G_Approvers_3,
      usersByGroup.G_Approvers_4,
    ].filter(group => group);

    const allUsers: User_CDMS[] = approverGroups.flatMap(group => group?.Users || []);
    this.ReviewerUsersUnifiedUpdate = this.GetUniqueUsers(allUsers);
    
    const newReviewerSlots: { [key: number]: User_CDMS[] } = {};
    for (let i = 1; i <= 4; i++) {
        let specificUsers: User_CDMS[] | undefined = undefined;

        if (i === 1 && usersByGroup.G_Approvers_1?.Users?.length > 0) {
            specificUsers = usersByGroup.G_Approvers_1.Users;
        } else if (i === 2 && usersByGroup.G_Approvers_2?.Users?.length > 0) {
            specificUsers = usersByGroup.G_Approvers_2.Users;
        } else if (i === 3 && usersByGroup.G_Approvers_3?.Users?.length > 0) {
            specificUsers = usersByGroup.G_Approvers_3.Users;
        } else if (i === 4 && usersByGroup.G_Approvers_4?.Users?.length > 0) {
            specificUsers = usersByGroup.G_Approvers_4.Users;
        }

        if (specificUsers) {
            newReviewerSlots[i] = this.GetUniqueUsers(specificUsers);
        } else {
            newReviewerSlots[i] = [...this.ReviewerUsersUnifiedUpdate];
        }
    }
    this.ReviewerUsersBySlotUpdate = newReviewerSlots;
  }

  private GetTaskUserIdBySlot(slot: number): number {
    const approvers = this.FFIN_Select_CM?.DynamicApprovers || [];
    const found = approvers.find((a: any) => a.ID_UR === slot);
    return found?.ID_Involved_User ?? -1;
  }

  private RefreshVisibleReviewersUpdate(): void {
    const slotsFromWorkflow = [1, 2, 3, 4].filter(slot => this.GetTaskUserIdBySlot(slot) > 0);

    if (slotsFromWorkflow.length > 0) {
      this.VisibleReviewersUpdate = slotsFromWorkflow;
      return;
    }

    const slotsFromForm = [1, 2, 3, 4].filter(slot => {
      const approver = this.FormFINUpdate?.controls[`Approver${slot}`]?.value;
      return typeof approver === 'object' && approver !== null && typeof approver.ID === 'number' && approver.ID > 0;
    });

    this.VisibleReviewersUpdate = slotsFromForm;
  }

  public GetApproverControlNameUpdate(slot: number): string {
    return `Approver${slot}`;
  }

  public GetReviewerUsersUpdate(slot: number): User_CDMS[] {
    return this.ReviewerUsersBySlotUpdate[slot] || [];
  }

  private GetReviewerHeaderKeyUpdate(slot: number): string {
    if (slot === 1) return this.Key_Header_FIN.APPR1;
    if (slot === 2) return this.Key_Header_FIN.APPR2;
    if (slot === 3) return this.Key_Header_FIN.APPR3;
    return this.Key_Header_FIN.APPR4;
  }

  public GetReviewerLabelUpdate(slot: number): string {
    const HeaderKey = this.GetReviewerHeaderKeyUpdate(slot);
    const Header = this.FIN_Table_Headers.find((item) => item.Key_Header === HeaderKey);
    return Header?.Name || `Revisor ${slot}`;
  }

  //&===================== FUNCTIONS FOR UPDATE FIN =====================&\\



  //-================== FUNCTTION FOR SWET ALERT ==================-\\
  private See_ModalExist_Update(): void {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'No puede guardar la actualización',
      text: '¡El proceso ya existe en este directorio con el mismo nombre!',
      confirmButtonColor: this.ColorConfirm
    }).then((results) => {
      if (results.isConfirmed) {
        this.ToggleModalUpdateFIN(false);
      }
    })
  }

  //-================== FUNCTTION FOR ADD FILE FIN ==================-\\
  public async AddDocument_Update(data: Event): Promise<void> {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      if (this.Is_Valid_File(file.name)) {

        this.FileAuxUpdFIN = {
          FileData: file,
          FileName: file.name
        }

        if (await this.checkFileIsEncrypted()) {
          this.Invalid_FileEncrypt(false);
          return;
        }

        this.FormFINUpdate.controls['NameFIN'].setValue(file.name);
        const Band = this.Check_FIN_in_Path_Directory(file.name, this.FFIN_Select_CM.ID);
        if (Band) {
          this.See_ModalExist_Update();
          this.ResetFormUpdate();
        }
        this.EnaOrDis_Optional_Reviewers()

      } else {
        this.Invalid_File_Update();
      }

    } else {
      this.Invalid_File_Update();
    }
  }

  private async checkFileIsEncrypted(): Promise<boolean> {
    try {

      const File_FormData = new FormData();
      File_FormData.append('File', this.FileAuxUpdFIN.FileData, this.FileAuxUpdFIN.FileName);

      const resVerifyFile: Response_FIN = await firstValueFrom(this.Service_FIN.Upload_CheckFileEncrypt(File_FormData));
      return resVerifyFile.operation;

    } catch (error) {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No se pudo verificar este archivo',
        text: '¡intente cargar nuevamente el archivo, si el problema persiste notifique a su supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      this.Invalid_FileEncrypt(true);
      return true;
    }
  }

  //-================== FUNCTION RESET FORM AND FILEAUX ==================-\\
  public override ResetFormUpdate() {
    this.FormFINUpdate.reset();
    this.FileAuxUpdFIN = {
      FileData: null,
      FileName: ''
    }
    this.MyInputUpdFile.nativeElement.value = null;
    this.MyInputUpdFileAnnexe.nativeElement.value = null;
    this.FileAuxUpdFIN_Annexes = [];
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL UPDATE OF FIN ==================-\\
  public override ToggleModalUpdateFIN(CloseOrOpen: boolean): void {
    this.Sync_File_Type_Config_FIN();
    this.ResetFormUpdate();
    const ModalUpdateFIN = document.getElementById('ModalUpdateFIN') as HTMLElement;
    CloseOrOpen ? ModalUpdateFIN.classList.add('active') : ModalUpdateFIN.classList.remove('active');

    // Reset de estado del botón de envío (Manual DOM Reset para animaciones)
    setTimeout(() => {
      const Text_Btn = document.getElementById('Text-Btn-Update') as HTMLSpanElement;
      const Send_Icon = document.getElementById('Send-Icon-Update') as HTMLElement;
      const Check_Icon = document.getElementById('Check-Icon-Update') as HTMLElement;
      const Btn = document.getElementById('BtnSavedFIN-Update') as HTMLButtonElement;

      if (Text_Btn && Send_Icon && Check_Icon) {
        Text_Btn.textContent = 'Enviar Proceso a Aprobación';
        Text_Btn.style.transform = `translateX(0px)`;
        Text_Btn.style.transition = 'none';
        Send_Icon.style.transform = `scale(1) translateX(0px)`;
        Send_Icon.style.transition = 'none';
        Check_Icon.style.opacity = `0`;
        Check_Icon.style.transform = 'translateY(-80px)';
        if (Btn) Btn.disabled = false;
      }
    }, 50);
  }

  private EnaOrDis_Optional_Reviewers() {

    for (let i = 1; i <= 4; i++) {
      const controlName = this.GetApproverControlNameUpdate(i);
      const control = this.FormFINUpdate.controls[controlName];
      const isVisible = this.VisibleReviewersUpdate.includes(i);
      const shouldDisableControl = !isVisible || this.NameFileFINUpdate.invalid;

      shouldDisableControl ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });

      if (isVisible && this.IsReviewerRequiredByPolicy(i)) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }

      if (!isVisible) {
        control.setValue('');
      }

      control.updateValueAndValidity({ emitEvent: false });
    }

  }

  private IsReviewerRequiredByPolicy(slot: number): boolean {
    if (!this.VisibleReviewersUpdate.includes(slot)) return false;

    if (this.Permission_FMF.Folder.Optional_Approvers === 0) {
      return true;
    }

    if (slot === 1) return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_1.gApproverFolderFIN.Required_RG;
    if (slot === 2) return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_2.gApproverFolderFIN.Required_RG;
    if (slot === 3) return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_3.gApproverFolderFIN.Required_RG;
    return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_4.gApproverFolderFIN.Required_RG;
  }


  //-================== FUNCTION TO CHECK THAT THE USERS ARE NOT REPLICATED IN THE FORM ==================-\\
  public UserIsReplicated_Update(Position: number): boolean {

    if (this.NameFileFINUpdate.invalid) return false;

    const currentSlot = Position + 1;

    if (!this.VisibleReviewersUpdate.includes(currentSlot)) return false;

    const currentApprover = this.FormFINUpdate.controls[this.GetApproverControlNameUpdate(currentSlot)].value;

    if (typeof currentApprover !== 'object' || currentApprover === null) return false;

    const otherApprovers = this.VisibleReviewersUpdate
      .filter(slot => slot !== currentSlot)
      .map(slot => this.FormFINUpdate.controls[this.GetApproverControlNameUpdate(slot)].value)
      .filter((approver: User_CDMS | string | null) => typeof approver === 'object' && approver !== null) as User_CDMS[];

    return otherApprovers.some((item: User_CDMS) => item.ID === currentApprover.ID);

  }

  //-================== FUNCTION IS VALID FORM ==================-\\
  private async IsValidFormFIN_Update(): Promise<boolean> {

    const IdInputFileUpdFIN = document.getElementById('IdInputFileUpdFIN') as HTMLElement; IdInputFileUpdFIN.classList.remove('Is-Invalid-Form');
    const IdinputCodeUpdFIN = document.getElementById('IdinputCodeUpdFIN') as HTMLElement;
    const IdinputPurpUpdFIN = document.getElementById('IdinputPurpUpdFIN') as HTMLElement;
    if (!this.FormFINUpdate.controls['NameFIN'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Archivo no valido',
        text: '¡Ingrese un archivo de Proceso!',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputFileUpdFIN.classList.add('Is-Invalid-Form');
      return false;
    }

    if (!this.FormFINUpdate.controls['Code'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Código no valido',
        text: '¡El Código es muy corto!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputCodeUpdFIN.classList.add('ng-invalid'); IdinputCodeUpdFIN.classList.add('ng-touched');
      return false;
    }

    if (!this.FormFINUpdate.controls['Purpose'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Objetivo del proceso no valido',
        text: '¡El Objetivo del proceso es muy corto!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputPurpUpdFIN.classList.add('ng-invalid'); IdinputPurpUpdFIN.classList.add('ng-touched');
      return false;
    }

    for (const slot of this.VisibleReviewersUpdate) {
      const controlName = this.GetApproverControlNameUpdate(slot);
      const control = this.FormFINUpdate.controls[controlName];
      const input = document.getElementById(`IdInputAuA${slot}UpdFIN`) as HTMLElement;
      const reviewerLabel = this.GetReviewerLabelUpdate(slot);

      if (!control.valid) {
        Swal.fire({
          icon: 'warning',
          title: `Usuario ${reviewerLabel} no valido`,
          text: `¡No ha seleccionado a un ${reviewerLabel}, por favor seleccione uno!`,
          confirmButtonColor: this.ColorConfirm
        })

        input?.classList.add('ng-invalid');
        input?.classList.add('ng-touched');
        return false;
      }

      if (!(control.value === "" || control.value === null)) {
        const reviewerValue: User_CDMS = control.value;

        if (reviewerValue.ID === undefined) {
          Swal.fire({
            icon: 'warning',
            title: `Usuario ${reviewerLabel} no valido`,
            text: `¡Seleccione un usuario ${reviewerLabel} proporcionado por el sistema!`,
            confirmButtonColor: this.ColorConfirm
          });

          input?.classList.add('ng-invalid');
          input?.classList.add('ng-touched');
          return false;
        }
      }
    }

    const Approvers: User_CDMS_Not_Dup[] = [];

    for (const slot of this.VisibleReviewersUpdate) {
      const Approver = this.FormFINUpdate.controls[this.GetApproverControlNameUpdate(slot)].value;
      if (typeof Approver === "object" && Approver !== null) {
        Approvers.push({ ID: Approver.ID, Name: Approver.Name, ID_UR: slot });
      }
    }


    const Index_Input: number[] = [];

    for (const [index, approver] of Approvers.entries()) {
      const Approvers_Clean = [...Approvers.slice(0, index), ...Approvers.slice(index + 1, Approvers.length)]

      for (const Approver of Approvers_Clean) {
        if (Approver.ID === approver.ID) {
          Index_Input.push(Approver.ID_UR); break;
        }
      }

    }

    if (Index_Input.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuarios repetidos',
        text: '¡No puede repetir los usuarios en los campos, intente cambiar alguno usuario!',
        confirmButtonColor: this.ColorConfirm
      });

      for (const Index of Index_Input) {
        const IdInputApproverUpdFIN = document.getElementById(`IdInputAuA${Index}UpdFIN`) as HTMLElement;
        IdInputApproverUpdFIN.classList.add('ng-invalid'); IdInputApproverUpdFIN.classList.add('ng-touched');
      }

      return false;
    }


    return await this.Validate_Annexes_Update();
  }

  //-================== FUNCTION FOR TOOGLE NOTIFICATION GROUPS ==================-\\
  public async ValidToogleFIN_Update(): Promise<void> {

    const IsValidForm: boolean = await this.IsValidFormFIN_Update();

    if (this.FormFINUpdate.valid && IsValidForm) {

      // Swal.fire({
      //   title: '¿Los datos son correctos?',
      //   text: "Si todo esta bien, presiona el botón para continuar",
      //   icon: 'question',
      //   showCancelButton: true,
      //   confirmButtonColor: this.ColorConfirm,
      //   cancelButtonColor: this.ColorsCancel,
      //   confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
      //   cancelButtonText: 'No, Cancelar',
      // }).then((result => {
      //   if (result.isConfirmed) {
      //     if (this.Group_Notification.length > 0) {
      //       this.ToggleModalNotificationUpdate(true);
      //     } else {
      //       Swal.fire({
      //         title: 'Notificación a grupos',
      //         text: "¡Aún no existen grupos para enviar notificación de la creación de un nuevo Proceso!",
      //         icon: 'question',
      //         confirmButtonColor: this.ColorConfirm,
      //       }).then((result2) => {
      //         if (result2.isConfirmed) {
      //           this.SendUpdateFIN([0]);
      //         }
      //       })
      //     }

      //     this.SendUpdateFIN([]);

      //   }
      // }))

      this.Toggle_Modal_Sweet_Alert_SendFIN_Update(true);
    }

  }

  //-================== FUNCTION TO CHECK IF NOTIFICATION GROUPS ARE SELECTED ==================-\\
  private Check_Notification_Update(): number[] {

    let Id_Groups: number[] = [];

    for (let i = 0; i < this.Group_Notification.length; i++) {
      const Group = this.Group_Notification[i];
      const CheckBox = document.getElementById(`CheckBoxUpdate${i}`) as HTMLInputElement;
      if (CheckBox.checked) {
        Id_Groups.push(Group.ID);
        CheckBox.checked = false;
      }
    }

    return Id_Groups;

  }

  //-================== FUNCTION FOR SAVED UPDATE FIN ==================-\\
  public async SavedUpdateFIN(): Promise<void> {

    const Id_Groups: number[] = this.Check_Notification_Update();

    if (this.FormFINUpdate.valid) {

      if (Id_Groups.length === 0) {
        Swal.fire({
          title: 'Sin notificación a grupos',
          text: "¡No ha seleccionado ningún grupo para notificación, ¿desea continuar sin notificaciones?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, continuar',
          cancelButtonText: 'No, Cancelar',
        }).then((results => {
          if (results.isConfirmed) {
            this.SendUpdateFIN(Id_Groups);
          }
        }))

      } else {

        Swal.fire({
          title: '¿Los grupos a notificar son correctos?',
          text: "Si todo esta bien, presiona el botón para continuar",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) {
            this.SendUpdateFIN(Id_Groups);
          }
        }))
      }

    }
  }

  //-================== FUNCTTION FOR SEND Update FIN ==================-\\
  private async SendUpdateFIN(Groups: number[]): Promise<void> {

    const NewNameCom = this.FormFINUpdate.controls['NameFIN'].value;
    const IsExistinPath = this.Check_FIN_in_Path_Directory(NewNameCom, this.FFIN_Select_CM.ID);

    this.ToggleModalNotificationUpdate(false);

    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puedes guardar esta actualización `,
        text: `¡El Proceso que proporcionó ya existe en el directorio y no es actualización de este mismo!`,
        confirmButtonColor: this.ColorConfirm
      })

      this.ToggleModalUpdateFIN(false);


    } else {



      this.ToggleModalNotificationUpdate(false);

      const Tasks: Task_FIN[] = [];

      const UserApprover1: User_CDMS = this.FormFINUpdate.controls['Approver1'].value;
      const UserApprover2: User_CDMS = this.FormFINUpdate.controls['Approver2'].value;
      const UserApprover3: User_CDMS = this.FormFINUpdate.controls['Approver3'].value;
      const UserApprover4: User_CDMS = this.FormFINUpdate.controls['Approver4'].value;

      (typeof UserApprover1 === "object" && UserApprover1 !== null) ? Tasks.push({ ID_Involved_User: UserApprover1.ID, ID_UR: 1 }) : Tasks.push({ ID_Involved_User: -1, ID_UR: 1 });
      (typeof UserApprover2 === "object" && UserApprover2 !== null) ? Tasks.push({ ID_Involved_User: UserApprover2.ID, ID_UR: 2 }) : Tasks.push({ ID_Involved_User: -1, ID_UR: 2 });
      (typeof UserApprover3 === "object" && UserApprover3 !== null) ? Tasks.push({ ID_Involved_User: UserApprover3.ID, ID_UR: 3 }) : Tasks.push({ ID_Involved_User: -1, ID_UR: 3 });
      (typeof UserApprover4 === "object" && UserApprover4 !== null) ? Tasks.push({ ID_Involved_User: UserApprover4.ID, ID_UR: 4 }) : Tasks.push({ ID_Involved_User: -1, ID_UR: 4 });



      const Annexes: FILE_CAP_Annexe_Update[] = [];

      for (const File_A of this.FileAuxUpdFIN_Annexes) {
        Annexes.push({ ID: File_A.ID, Name: File_A.FileName, Extension: File_A.Extension, Status: File_A.Status, UpdateAnnexe: { Name: File_A.UpdateAnnexe.FileName, Extension: File_A.UpdateAnnexe.Extension } });
      }

      const SC_Workflow_FIN: WorkFlow_FIN = {
        ID_Contributor: this.ID_User_BD,
        ID_Previous_Version: this.FFIN_Select_CM.ID,
        ID_Folder: this.Permission_FMF.Folder.ID,
        Name: this.FormFINUpdate.controls['NameFIN'].value,
        Extension: this.FormFINUpdate.controls['NameFIN'].value.split('.').pop(),
        Code: this.FormFINUpdate.controls['Code'].value,
        Purpose: this.FormFINUpdate.controls['Purpose'].value,
        Revision_No: 0,
        Tasks: Tasks,
        Notification: Groups,
        Annexes: Annexes
      };

      const WorkflowPayload: any = {
        ...SC_Workflow_FIN,
        UploadFileType: this.Get_Selected_Main_File_Type_FIN(),
        AllowAnyFileType: true  // Carga individual acepta cualquier tipo de archivo
      };

      const Content_Progress = document.getElementById('Content-Progress') as HTMLDivElement;
      const Progress_Bar = document.getElementById('Progress-Bar') as HTMLDivElement;


      try {

        const Send_Icon = document.getElementById('Send-Icon') as HTMLElement;
        const Text_Btn = document.getElementById('Text-Btn') as HTMLSpanElement;

        this.OnDisabledAdd_Update(true);

        Send_Icon.style.transform = `scale(0.5) translateX(-200px)`;
        Text_Btn.textContent = 'Enviando';
        Text_Btn.style.transform = `translateX(-10px)`;

        const ResUpdateWorkflow: Response_FIN = await firstValueFrom(this.Service_FIN.Update_Workflow(WorkflowPayload));


        if (ResUpdateWorkflow.success) {

          const WorkFlow_Upd = ResUpdateWorkflow.operation.Workflow;
          const ID_WF_Upd = WorkFlow_Upd.ID;

          const Annexes_Last_Current_Update: Annexes_Current_Last[] = ResUpdateWorkflow.operation.Annexe_Update;

          const Route_Saved_FIN: string = encodeURIComponent(this.Route_Level_Global + '/' + ID_WF_Upd + '/' + ID_WF_Upd + '.' + SC_Workflow_FIN.Extension);

          const File_FormData = new FormData();
          File_FormData.append('FileFIN', this.FileAuxUpdFIN.FileData, Route_Saved_FIN);

          Content_Progress.classList.add('active')

          this.Service_FIN.Upload_File(File_FormData).subscribe(async (event: any) => {

            if (event.status === 500) {

              this.OnDisabledAdd_Update(false);
              Content_Progress.classList.remove('active')
              Progress_Bar.style.width = "0%";

              Swal.fire({
                title: 'Error en el Proceso',
                text: '¡Ha ocurrido un error al cargar la actualización de el Proceso, informe al supervisor!',
                icon: 'warning',
                confirmButtonColor: this.ColorConfirm
              })

              this.ToggleModalUpdateFIN(false);
              this.IsUpdateFINBool.emit(true);
            }

            if (event['loaded'] && event['total']) {
              let value = (Math.round(event['loaded'] / event['total'] * 100));
              Progress_Bar.style.width = value + "%";
            }

            if (event['body']) {
              this.OnDisabledAdd_Update(false);
              Content_Progress.classList.remove('active')
              Progress_Bar.style.width = "0%";


              await this.Send_Annexes_Update(ID_WF_Upd, Annexes_Last_Current_Update)

              this.AnimationBbuttonSave_Update();
              this.IsUpdateFINBool.emit(true);
            }

          })

        }


      } catch (e) {

        Swal.fire({
          title: 'Error en el Proceso',
          text: '¡No se guardo el archivo de el Proceso en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        this.OnDisabledAdd_Update(false);
        Content_Progress.classList.remove('active')
        Progress_Bar.style.width = "0%";
        this.ToggleModalUpdateFIN(false);

      }

    }

  }

  //-================== FUNCTION FOR DISABLED BUTTONS IN FIN FORM WHILE SENDING ==================-\\
  private OnDisabledAdd_Update(IsDisabled: boolean): void {

    const Btn = document.getElementById('BtnSavedFIN-Update') as HTMLButtonElement;
    const Btn_Close_Upd_Top = document.getElementById('Btn-Close-Upd-Top') as HTMLButtonElement;
    const Btn_Close_Upd_Bottom = document.getElementById('Btn-Close-Upd-Bottom') as HTMLButtonElement;

    if (IsDisabled) {
      Btn.disabled = true;
      Btn_Close_Upd_Top.disabled = true;
      Btn_Close_Upd_Bottom.disabled = true;
    } else {
      Btn.disabled = false;
      Btn_Close_Upd_Top.disabled = false;
      Btn_Close_Upd_Bottom.disabled = false;
    }

  }

  //-================== FUNCTTION FOR ADD FILE ANNEXE ==================-\\
  public async Add_Document_Annexe_Upd(data: Event): Promise<void> {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      if (!this.FileAuxUpdFIN_Annexes.some(item => item.FileName === file.name && item.Status != 5)) {
        const isEncrypted: boolean = await this.checkAnnexeIsEncrypted({ FileData: file, FileName: file.name })

        if (!isEncrypted) {
          this.FileAuxUpdFIN_Annexes.push({ ID: 0, FileData: file, FileName: file.name, Extension: file.name.split('.').pop() || "", Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } });
          this.MyInputUpdFileAnnexe.nativeElement.value = null;
        } else {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Archivo protegido con contraseña',
            text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
            confirmButtonColor: this.ColorConfirm
          });
          this.MyInputUpdFileAnnexe.nativeElement.value = null;
        }

      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: 'El anexo ya está cargado'
        })
      }


    }

    this.MyInputUpdFileAnnexe.nativeElement.value = null;

  }

  //-================== FUNCTTION FOR DELETE FILE ANNEXE ==================-\\
  public Delete_Annexe_Upd(Name_Annexe: string): void {

    Swal.fire({
      title: 'Eliminar anexo',
      text: `¿Desea eliminar el anexo ${Name_Annexe}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {
        this.FileAuxUpdFIN_Annexes = this.FileAuxUpdFIN_Annexes.filter(item => item.FileName !== Name_Annexe);
      }

    }))

  }

  public Delete_Annexe_Update_Modal(Name_Annexe: string): void {

    Swal.fire({
      title: 'Eliminar anexo',
      text: `¿Desea eliminar el anexo ${Name_Annexe}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {

        const Annexe_X: FILE_CAP_Annexe_ID | undefined = this.FileAuxUpdFIN_Annexes.find(item => item.FileName === Name_Annexe);

        if (Annexe_X != undefined) {
          if (Annexe_X.ID === 0) {
            this.FileAuxUpdFIN_Annexes = this.FileAuxUpdFIN_Annexes.filter(item => item.FileName !== Name_Annexe);
          } else {
            this.FileAuxUpdFIN_Annexes.forEach((item: FILE_CAP_Annexe_ID) => {
              if (item.FileName === Name_Annexe) {
                item.Status = 5;
              }
            })
          }
        }
      }

    }))

  }

  //-================== FUNCTTION FOR DELETE FILE ANNEXE ==================-\\
  public Delete_Annexe_Upd_Update(Name_Annexe: string): void {

    Swal.fire({
      title: 'Eliminar anexo',
      text: `¿Desea eliminar el anexo ${Name_Annexe}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {
        this.FileAuxUpdFIN_Annexes = this.FileAuxUpdFIN_Annexes.filter(item => item.FileName !== Name_Annexe);
      }

    }))

  }

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL UPDATE ANNEXE ==================-\\
  public override Toogle_Modal_Update_Annexe(CloseOrOpen: boolean): void {

    this.MyInputUpdFile_Update_Annexe.nativeElement.value = null;
    this.FileAuxUpdFIN_Annexe_Update = { ID: 0, FileData: '', FileName: '', Extension: '', Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } };

    const Modal_Update_Annexe = document.getElementById('Modal_Update_Annexe') as HTMLElement;
    CloseOrOpen ? Modal_Update_Annexe.classList.add('active') : Modal_Update_Annexe.classList.remove('active');
  }

  //-================== FUNCTTION UPDATE ANNEXE ==================-\\
  public async Annexe_Update(Annexe: FILE_CAP_Annexe_ID): Promise<void> {

    this.Toogle_Modal_Update_Annexe(true);

    this.FileAuxUpdFIN_Annexe_Update = Annexe;

  }

  //-================== FUNCTTION FOR ADD UPDATE ANNEXE ==================-\\
  public Add_Annexe_Update(data: Event): void {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      const IsExist: boolean = this.Validate_Exisit_Update_Annexe(file);

      if (IsExist) {

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: 'El anexo de actualización ya esta cargado en otro anexo'
        })

      } else {

        for (const Annexe of this.FileAuxUpdFIN_Annexes) {
          if (Annexe.ID === this.FileAuxUpdFIN_Annexe_Update.ID) {
            Annexe.UpdateAnnexe = { FileData: file, FileName: file.name, Extension: file.name.split('.').pop() || '' };
            this.FileAuxUpdFIN_Annexe_Update = Annexe; break;
          }
        }
      }

    }

    this.MyInputUpdFile_Update_Annexe.nativeElement.value = null;

  }

  //-================== FUNCTTION FOR VALIDATE ANNEXE ==================-\\
  private Validate_Exisit_Update_Annexe(file: File): boolean {
    for (const Annexe of this.FileAuxUpdFIN_Annexes) {
      if (Annexe.UpdateAnnexe.FileName === file.name) {
        return true;
      }
    }
    return false;
  }

  //-================== FUNCTTION FOR DELETE UPLOAD ANNEXE ==================-\\
  public Delete_Update_Annexe(): void {

    Swal.fire({
      title: 'Eliminar actualización de anexo',
      text: `¿Desea eliminar la actualización del anexo ${this.FileAuxUpdFIN_Annexe_Update.FileName}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {

        for (const Annexe of this.FileAuxUpdFIN_Annexes) {
          if (Annexe.ID === this.FileAuxUpdFIN_Annexe_Update.ID) {
            Annexe.UpdateAnnexe = { FileData: '', FileName: '', Extension: '' };
            this.FileAuxUpdFIN_Annexe_Update = Annexe; break;
          }
        }
        this.Toogle_Modal_Update_Annexe(false);
      }

    }))


  }

  //-================== FUNCTTION FOR SHOW MESSAGE INVALID FILE ==================-\\
  private Invalid_File_Update(): void {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'No se puede cargar este documento',
      text: this.Get_Invalid_File_Message_FIN(),
      confirmButtonColor: this.ColorConfirm
    });

    this.FileAuxUpdFIN = {
      FileData: null,
      FileName: ''
    }
    this.FormFINUpdate.controls['NameFIN'].setValue('');
    this.MyInputUpdFile.nativeElement.value = null;
  }

  private Invalid_FileEncrypt(error: boolean): void {
    if (!error) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Archivo protegido con contraseña',
        text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
        confirmButtonColor: this.ColorConfirm
      });
    }

    this.FileAuxUpdFIN = {
      FileData: null,
      FileName: ''
    }
    this.FormFINUpdate.controls['NameFIN'].setValue('');
    this.MyInputUpdFile.nativeElement.value = null;
  }

  //-================== FUNCTTION FOR SEND ANNEXES ==================-\\
  private async Send_Annexes_Update(ID_WF: number, Annexes: Annexes_Current_Last[]): Promise<boolean> {

    return new Promise((resolve, reject) => {

      const Annexes_Send: Annexes_Current_Last_Data[] = [];


      for (const Annexe of Annexes) {
        for (const Annexe_Data of this.FileAuxUpdFIN_Annexes) {
          if (Annexe.Current_Annexe.Name === Annexe_Data.UpdateAnnexe.FileName) {
            Annexes_Send.push({
              Last_Annexe: { ID: Annexe.Last_Annexe.ID, Name: Annexe.Last_Annexe.Name, Extension: Annexe.Last_Annexe.Extension, Status: Annexe.Last_Annexe.Status },
              Current_Annexe: { ID: Annexe.Current_Annexe.ID, Name: Annexe.Current_Annexe.Name, Extension: Annexe.Current_Annexe.Extension, Status: Annexe.Current_Annexe.Status, FileData: Annexe_Data.UpdateAnnexe.FileData }
            })
          }
        }
      }

      for (const Annexe of Annexes) {
        for (const Annexe_Data of this.FileAuxUpdFIN_Annexes) {
          if (Annexe.Current_Annexe.Status === 1 && Annexe.Current_Annexe.Name === Annexe_Data.FileName) {
            Annexes_Send.push({
              Last_Annexe: { ID: Annexe.Last_Annexe.ID, Name: Annexe.Last_Annexe.Name, Extension: Annexe.Last_Annexe.Extension, Status: Annexe.Last_Annexe.Status },
              Current_Annexe: { ID: Annexe.Current_Annexe.ID, Name: Annexe.Current_Annexe.Name, Extension: Annexe.Current_Annexe.Extension, Status: Annexe.Current_Annexe.Status, FileData: Annexe_Data.FileData }
            })
          }
        }
      }

      const Files_Annexes = new FormData();

      Annexes_Send.forEach((file: Annexes_Current_Last_Data) => {

        const Route_Saved_FIN: string = encodeURIComponent(ID_WF + '_' + file.Current_Annexe.ID + '.' + file.Current_Annexe.Extension);
        Files_Annexes.append('Files_Annexes', file.Current_Annexe.FileData, Route_Saved_FIN);
      })

      Files_Annexes.append('ID_WF', `${ID_WF}`);
      Files_Annexes.append('IsUpdate', 'true');

      const Content_Progress = document.getElementById('Content-Progress-Update') as HTMLDivElement;
      const Progress_Bar = document.getElementById('Progress-Bar-Update') as HTMLDivElement;

      try {

        Content_Progress.classList.add('active');

        this.Service_FIN.Upload_Annexes(Files_Annexes).subscribe(async (event: any) => {

          if (event.status === 500) {

            this.OnDisabledAdd_Update(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en los anexos de el Proceso',
              text: '¡Ha ocurrido un error al cargar la actualización de los anexos de el Proceso, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModalUpdateFIN(false);

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar.style.width = value + "%";
          }

          if (event['body']) {
            this.OnDisabledAdd_Update(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            resolve(true);
          }

        })

      } catch (e) {

        Swal.fire({
          title: 'Error en el Proceso (Carga anexos actualización)',
          text: '¡No se guardo el archivo anexos de el Proceso en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }



    })
  }

  public Toggle_Modal_Sweet_Alert_SendFIN_Update(band: boolean): void {
    const modal = document.getElementById('Sweet_Alert_Update') as HTMLDivElement;
    setTimeout(() => { band ? (modal.classList.add('active')) : (modal.classList.remove('active')) }, 100);

  }

  public Sweet_Alert_Send_New_FIN_Update(): void {
    this.Toggle_Modal_Sweet_Alert_SendFIN_Update(false);
    this.SendUpdateFIN([0]);
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL NOTIFICATION TO GROUPS ==================-\\
  private ToggleModalNotificationUpdate(band: boolean): void {

    const modal = document.getElementById('ModalNotificationFINUpdate') as HTMLDivElement;

    band ? (modal.classList.add('active')) : (modal.classList.remove('active'))

  }

  //-================== FUNCTION IS VALIDATE ANNEXES ==================-\\
  private Validate_Annexes_Update(): Promise<boolean> {

    return new Promise<any>((resolve, reject) => {

      if (this.FileAuxUpdFIN_Annexes.length === 0) {
        Swal.fire({
          title: 'Sin anexos',
          text: "¡No adjunto anexos, ¿está seguro de enviar sin anexos?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: 'Sí, enviar',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) { resolve(true) } else { resolve(false) };
        }))
      } else {
        resolve(true);
      }

    })
  }


  private AnimationBbuttonSave_Update(): void {

    const Send_Icon = document.getElementById('Send-Icon-Update') as HTMLElement;
    const Check_Icon = document.getElementById('Check-Icon-Update') as HTMLElement;
    const Text_Btn = document.getElementById('Text-Btn-Update') as HTMLSpanElement;
    const Btn = document.getElementById('BtnSavedFIN-Update') as HTMLButtonElement;




    Text_Btn.style.transform = `translateY(80px)`;
    Text_Btn.classList.remove('loading')
    Send_Icon.style.transition = `1000ms ease 230ms`;
    Send_Icon.style.transform = `scale(2) translateX(120px)`;
    setTimeout(() => {
      Check_Icon.style.opacity = `1`;

      Text_Btn.classList.add('notransition');
      Text_Btn.style.transform = `translateY(0px)`;
      Text_Btn.textContent = 'Enviado';
      Text_Btn.offsetHeight;
      Text_Btn.classList.remove('notransition');

      Check_Icon.style.transform = `translate(-20px,0px)`;
      setTimeout(() => {
        this.ToggleModalUpdateFIN(false);
        Text_Btn.textContent = this.GetSubmitButtonTextUpdate();
        Check_Icon.style.opacity = `0`;
        Check_Icon.style.transform = 'translateY(-80px)';
        Send_Icon.style.transform = 'scale(1) translateX(0px)';
        Btn.disabled = false;
        Swal.fire({
          icon: 'success',
          title: 'Proceso enviado a revisión',
          confirmButtonColor: this.ColorConfirm
        })
      }, 500);
    }, 1000);

  }

  //&===================== END FUNCTIONS FOR UPDATE FIN =====================&\\





  //&===================== FUNCTIONS FOR UPDATE ANNEXES FOR APPROVED FIN =====================&\\

  //-================== FUNCTION FOR VALIDATE UPDATE ANNEXES ==================-\\
  public Validate_Update_Annexes_Approved(): void {

    Swal.fire({
      title: 'Actualización de anexos',
      icon: 'warning',
      text: `¿esta seguro de actualizar los anexos?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Actualizar',
      cancelButtonText: 'No, Cancelar',
    }).then(result => {

      if (result.isConfirmed) {
        if (this.FileAuxUpdFIN_Annexes.length > 0) {
          this.Send_Update_Annexes_Approved();
        } else {
          Swal.fire({
            title: 'Sin anexos',
            text: "¡No adjunto anexos, ¿está seguro de no enviar anexos (dejará sin anexos al Proceso)?! ",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            confirmButtonText: 'Sí, enviar',
            cancelButtonText: 'No, Cancelar',
          }).then((result) => {
            if (result.isConfirmed) {
              this.Send_Update_Annexes_Approved();
            }
          })
        }
      }
    })


  }

  //-================== FUNCTION FOR SEND ANNEXES UPDATE ==================-\\
  private async Send_Update_Annexes_Approved(): Promise<void> {

    const Annexes: FILE_CAP_Annexe_Update[] = [];


    for (const File_A of this.FileAuxUpdFIN_Annexes) {

      if (File_A.UpdateAnnexe.FileName !== '' || File_A.Status === 5 || File_A.ID === 0) {
        Annexes.push({ ID: File_A.ID, Name: File_A.FileName, Extension: File_A.Extension, Status: File_A.Status, UpdateAnnexe: { Name: File_A.UpdateAnnexe.FileName, Extension: File_A.UpdateAnnexe.Extension } });
      }

    }

    const Content_Progress = document.getElementById('Content-Progress-Update-Annexes-Approved') as HTMLDivElement;
    const Progress_Bar = document.getElementById('Progress-Bar-Update-Annexes-Approved') as HTMLDivElement;

    try {

      const Send_Icon = document.getElementById('Send-Icon-Update-Annexes-Approved') as HTMLElement;
      const Text_Btn = document.getElementById('Check-Icon-Update-Annexes-Approved') as HTMLSpanElement;

      this.OnDisabled_Update_Ann_App(true);

      Send_Icon.style.transform = `scale(0.5) translateX(-200px)`;
      Text_Btn.textContent = 'Enviando';
      Text_Btn.style.transform = `translateX(-10px)`;


      const ResUpdate_Annexes: Response_FIN = await firstValueFrom(this.Service_FIN.Update_Annexes({ Annexes_Update: Annexes, ID_WF: this.FFIN_Select_CM.ID, ID_Contributor: this.ID_User_BD }));

      if (ResUpdate_Annexes.success) {

        Content_Progress.classList.add('active')

        const Annexes_Last_Current_Update: Annexes_Current_Last[] = ResUpdate_Annexes.operation.Annexe_Update;

        await this.Send_Annexes_Update_Approved(this.FFIN_Select_CM.ID, Annexes_Last_Current_Update);

        this.AnimationBbuttonSave_Update_Annexe();

        this.IsUpdateFINBool.emit(true);
      }


    } catch (e) {

      Swal.fire({
        title: 'Error en el Proceso',
        text: '¡No se guardó la actualización de los anexos, informe a su supervisor! ',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      this.OnDisabled_Update_Ann_App(false);
      Content_Progress.classList.remove('active')
      Progress_Bar.style.width = "0%";
      this.ToggleModal_Update_Annexes_Approved(false);


    }

  }

  //-================== FUNCTTION FOR SEND ANNEXES ==================-\\
  private async Send_Annexes_Update_Approved(ID_WF: number, Annexes: Annexes_Current_Last[]): Promise<boolean> {

    return new Promise((resolve, reject) => {

      const Annexes_Send: Annexes_Current_Last_Data[] = [];


      for (const Annexe of Annexes) {
        for (const Annexe_Data of this.FileAuxUpdFIN_Annexes) {
          if (Annexe.Current_Annexe.Name === Annexe_Data.UpdateAnnexe.FileName && Annexe.Current_Annexe.Status != 5) {
            Annexes_Send.push({
              Last_Annexe: { ID: Annexe.Last_Annexe.ID, Name: Annexe.Last_Annexe.Name, Extension: Annexe.Last_Annexe.Extension, Status: Annexe.Last_Annexe.Status },
              Current_Annexe: { ID: Annexe.Current_Annexe.ID, Name: Annexe.Current_Annexe.Name, Extension: Annexe.Current_Annexe.Extension, Status: Annexe.Current_Annexe.Status, FileData: Annexe_Data.UpdateAnnexe.FileData }
            })
          }
        }
      }

      for (const Annexe of Annexes) {
        for (const Annexe_Data of this.FileAuxUpdFIN_Annexes) {
          if (Annexe.Current_Annexe.Status === 1 && Annexe.Current_Annexe.Name === Annexe_Data.FileName && Annexe_Data.ID === 0) {
            Annexes_Send.push({
              Last_Annexe: { ID: Annexe.Last_Annexe.ID, Name: Annexe.Last_Annexe.Name, Extension: Annexe.Last_Annexe.Extension, Status: Annexe.Last_Annexe.Status },
              Current_Annexe: { ID: Annexe.Current_Annexe.ID, Name: Annexe.Current_Annexe.Name, Extension: Annexe.Current_Annexe.Extension, Status: Annexe.Current_Annexe.Status, FileData: Annexe_Data.FileData }
            })
          }
        }
      }

      const Files_Annexes = new FormData();

      Annexes_Send.forEach((file: Annexes_Current_Last_Data) => {

        if (file.Current_Annexe.FileData) {
          const Route_Saved_FIN: string = encodeURIComponent(ID_WF + '_' + file.Current_Annexe.ID + '.' + file.Current_Annexe.Extension);
          Files_Annexes.append('Files_Annexes', file.Current_Annexe.FileData, Route_Saved_FIN);
        } else {
          Swal.fire({
            title: 'Error al cargar el archivo' + file.Current_Annexe.Name,
            text: '¡informe al supervisor, de lo contrario no se podra descargar este documento!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }


      })

      Files_Annexes.append('ID_WF', `${ID_WF}`);

      const Content_Progress = document.getElementById('Content-Progress-Update-Annexes-Approved') as HTMLDivElement;
      const Progress_Bar = document.getElementById('Progress-Bar-Update-Annexes-Approved') as HTMLDivElement;

      try {

        Content_Progress.classList.add('active');

        this.Service_FIN.Upload_Annexes_Update(Files_Annexes).subscribe(async (event: any) => {

          if (event.status === 500) {

            this.OnDisabled_Update_Ann_App(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en los anexos de el Proceso',
              text: '¡Ha ocurrido un error al cargar la actualización de los anexos de el Proceso, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModal_Update_Annexes_Approved(false);

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar.style.width = value + "%";
          }

          if (event['body']) {
            this.OnDisabled_Update_Ann_App(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            resolve(true);
          }

        })

      } catch (e) {

        Swal.fire({
          title: 'Error en el Proceso (Carga anexos actualización)',
          text: '¡No se guardo el archivo anexos de el Proceso en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }



    })
  }

  private AnimationBbuttonSave_Update_Annexe(): void {

    const Send_Icon = document.getElementById('Send-Icon-Update-Annexes-Approved') as HTMLElement;
    const Check_Icon = document.getElementById('Check-Icon-Update-Annexes-Approved') as HTMLElement;
    const Text_Btn = document.getElementById('Text-Btn-Update-Annexes-Approved') as HTMLSpanElement;
    const Btn = document.getElementById('BtnSavedFIN-Update-Annexes-Approved') as HTMLButtonElement;


    Text_Btn.style.transform = `translateY(80px)`;
    Text_Btn.classList.remove('loading')
    Send_Icon.style.transition = `1000ms ease 230ms`;
    Send_Icon.style.transform = `scale(2) translateX(120px)`;
    setTimeout(() => {
      Check_Icon.style.opacity = `1`;

      Text_Btn.classList.add('notransition');
      Text_Btn.style.transform = `translateY(0px)`;
      Text_Btn.textContent = 'Anexos Actualizados';
      Text_Btn.offsetHeight;
      Text_Btn.classList.remove('notransition');

      Check_Icon.style.transform = `translate(-20px,0px)`;
      setTimeout(() => {
        this.ToggleModal_Update_Annexes_Approved(false);
        Text_Btn.textContent = 'Actualizar anexos';
        Check_Icon.style.opacity = `0`;
        Check_Icon.style.transform = 'translateY(-80px)';
        Send_Icon.style.transform = 'scale(1) translateX(0px)';
        Btn.disabled = false;
        Swal.fire({
          icon: 'success',
          title: 'Anexos Actualizados',
          confirmButtonColor: this.ColorConfirm
        })
      }, 500);
    }, 1000);

  }

  public VerifySweetAlert() {

    const Sweet_Alert = document.getElementById('Sweet_Alert_Update') as HTMLDivElement;
    window.onclick = (event: any) => {

      if (!event.target.closest('.Sweet-Alert') && Sweet_Alert.classList.contains('active')) {
        if (Sweet_Alert.classList.contains('active')) {
          this.Toggle_Modal_Sweet_Alert_SendFIN_Update(false);
        }
      }

    }
  }

  //&===================== END FUNCTIONS FOR UPDATE ANNEXES FOR APPROVED FIN =====================&\\


  public GetSubmitButtonTextUpdate(): string {
    const noReviewers = !this.VisibleReviewersUpdate || this.VisibleReviewersUpdate.length === 0;
    return noReviewers ? 'Cargar y Aprobar Proceso' : 'Enviar Proceso a Aprobación';
  }

  public GetSubmitButtonIconUpdate(): string {
    const noReviewers = !this.VisibleReviewersUpdate || this.VisibleReviewersUpdate.length === 0;
    return noReviewers ? 'check_circle' : 'send';
  }
}
